// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "header-3F9Md";
var _4 = "header__text-1wLFA";
var _5 = "content-Dvf4Y";
var _6 = "service-V-kZm";
var _7 = "service_active-3oi2d";
var _8 = "header__price-15IUp";
var _9 = "business-2ZK7C";
var _a = "priority-1ZB27";
var _b = "paper-A8hqo";
var _c = "business__header-34L4N";
var _d = "insurance-3gT43";
var _e = "priority__header-1EFVy";
var _f = "serviceWrapperEndAdornment-11XT6";
export { _1 as "__esModule", _2 as "mobile", _3 as "header", _4 as "header__text", _5 as "content", _6 as "service", _7 as "service_active", _8 as "header__price", _9 as "business", _a as "priority", _b as "paper", _c as "business__header", _d as "insurance", _e as "priority__header", _f as "serviceWrapperEndAdornment" }
export default { "__esModule": _1, "mobile": _2, "header": _3, "header__text": _4, "content": _5, "service": _6, "service_active": _7, "header__price": _8, "business": _9, "priority": _a, "paper": _b, "business__header": _c, "insurance": _d, "priority__header": _e, "serviceWrapperEndAdornment": _f }
